<template>
  <div>
    <div class="back" @click="back" v-if="isCollect">
      <i></i>
      <span>返回</span>
    </div>
    <div class="showlabel" v-if="isCollect">
      <!-- <h4>选择题库</h4> -->
      <!-- <div class="testtype">组件模式：{{ groupmode }}</div>
      <div class="testtype">命题方式：{{ unified }}</div>
      <div class="testtype" @click="addquestionbank">添加题库</div> -->
    </div>

    <el-dialog
      title="选择试卷"
      :close-on-click-modal="false"
      :visible.sync="indexDialogVisible"
      :before-close="handleClose"
      width="30%"
    >
      <el-form :model="dialogForm">
        <el-form-item label="分组名称：" label-width="100px">
         <el-select v-model="dialogForm.className" @change='selectClassName' placeholder="请选择">
            <el-option
              v-for="item in dialogForm.classNameOptions"
              :key="item.value"
              :label="item.AppClassName"
              :value="item.AppClassID"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="试卷名称：" label-width="100px">
          <el-select v-model="dialogForm.ExamName" placeholder="请先选择分组">
            <el-option
              v-for="item in dialogForm.ExamNameOptions"
              :key="item.value"
              :label="item.AppClassName"
              :value="item.ID + ',,,'+item.AppClassName+ ',,,'+item.appid"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="moveDialogList">确 定</el-button>
      </span>
    </el-dialog>

    <transition name="fade-transform">
      <component :is="coms" ref="sonComponent" :custom="custom"></component>
    </transition>
  </div>
</template>

<script>
import {
  ChapterThree,AddCollecttest
} from "@/api/quebankmana.js";
import loginvuex from "@/store/index";
export default {
  data() {
    return {
      dialogForm: {
        classNameOptions:'',//全部分组选项
        className: "", //分组名字
        ExamNameOptions:'',//试卷选项
        ExamName: "", //试卷名字  第一个是cptid，第二个是试卷命，第三个是appid
      },
      treeData:'',//一级树ID 开始查试卷
      indexDialogVisible: false, //弹窗关闭唤起
      isActive: 0,
      isCollect: false,
    };
  },
  components: {
    Pageone: () => import("./component/page.vue"), //第一步
    accuratepagetwo: () =>
      import(
        "../../theonlineTest/published/components/newaddpaper/components/accuratepagetwo.vue"
      ), //精准组卷
  },
  methods: {
    custom(index) {
      this.isActive = index;
      if (index == 0) {
        this.isCollect = 0;
      }
      if (index == 1) {
        this.indexDialogVisible = true
        setTimeout(() => {
          this.isCollect = true;
          this.$refs.sonComponent.isCollect = true;
        }, 300);
      }
    },
    selectClassName(val){
      //分组名选择后
      console.log(val);
      this.dialogForm.ExamName = ''
      let res = {
          ClassID: val,
          guid: JSON.parse(loginvuex.state.userlist).guid,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          hid: JSON.parse(loginvuex.state.hid),
        };
        ChapterThree(res).then((resa)=>{
          console.log(resa);
          if(resa.data.Data.Three.length == 0){
            this.dialogForm.ExamNameOptions = []
          }else{
            this.dialogForm.ExamNameOptions = resa.data.Data.Three.map((item) => {
            let newobj = {};
            if(item.Childs.length != 0){
              newobj["ID"] =item.Childs[0].Childs[0].Childs[0].ID;
              newobj['appid'] = item.ID
            newobj["AppClassName"] = item.Name;
            newobj['leaf'] = true
            }else{
              newobj["ID"] = '-1';
              newobj['appid'] = item.ID
              newobj["AppClassName"] = item.Name;
            }
            return newobj;
          });
          console.log(this.dialogForm.ExamNameOptions);
          }
        })
    },
    cancel(){
      //取消弹窗逻辑
      this.indexDialogVisible = false;
      this.dialogForm.className = '';
      this.dialogForm.ExamName = '';
            this.custom(0);
      // this.$confirm('确认关闭选择试卷？返回列表','提示')
      //     .then(_ => {
      //       this.indexDialogVisible = false
      //       this.custom(0);
      //     })
      //     .catch(_ => {});
    },
    moveDialogList(){
      if(this.dialogForm.ExamName === ''){
        this.$message.error('请选择试卷');
        return
      }
      this.indexDialogVisible = false;
      this.dialogForm.classNameOptions = [];
       this.dialogForm.ExamNameOptions = [];
      console.log(this.dialogForm);
    },
    savetest(testid){
      let newarr = this.dialogForm.ExamName.split(',,,');
      console.log(newarr);
      let pamasr= {
        cptID:newarr[0],
          guid: JSON.parse(loginvuex.state.userlist).guid,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          hid: JSON.parse(loginvuex.state.hid),
          TestIdArr:JSON.stringify(testid),
          AppID:newarr[2],
          ChapterName:newarr[1]
      }
       this.dialogForm.className = '';
      this.dialogForm.ExamName = '';
      console.log(pamasr);
     AddCollecttest(pamasr)
    },
    handleClose(done){
      //关闭前选择
     this.$confirm('确认关闭选择试卷？返回列表','提示')
          .then(_ => {
            done();
            this.custom(0);
          })
          .catch(_ => {});
    },
    back() {
      this.custom(0);
    },
  },
  computed: {
    coms() {
      switch (this.isActive) {
        case 0:
          return "Pageone";
        case 1:
          return "accuratepagetwo";
      }
      return "ss";
    },
  },
  created() {
    console.log(this.coms);
  },
};
</script>

<style lang="scss" scoped>
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.showlabel {
  width: 100%;
  height: 98px;
  background-color: rgb(255, 255, 255);
  margin-bottom: 24px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  h4 {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 20px;
    color: #333333;
    padding-left: 24px;
    padding-right: 24px;
  }
  .testtype {
    padding-left: 24px;
    padding-right: 24px;
    height: 50px;
    background: #eeeeee;
    opacity: 1;
    border-radius: 4px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 50px;
    margin-right: 50px;
    &:nth-child(4) {
      background-color: #1890ff;
      color: #ffffff;
      padding-left: 49px;
      padding-right: 49px;
      cursor: pointer;
    }
  }
}
::v-deep .el-dialog__header{
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  background: linear-gradient(180deg, #64b5ff 0%, #c7e4ff 100%);
}
::v-deep .el-dialog{
  margin-top: 15% !important;
}
::v-deep .el-select{
  width: 80%;
}
::v-deep .el-dialog__footer{
  text-align: center;
}
</style>